import { FC } from 'react'

import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import { AdCampaignStrategyEnum } from 'src/Redux/ad-campaignApi'

import { NoAuthPageLayout } from '../../Components/NoAuthPageLayout'
import { HelmetTitle } from '../../Components/HelmetTitle'
import { SearchPlaylistFormNoAuth } from '../ArtistRegisterPageMetaAds/Components/SearchPlaylistFormNoAuth/SearchPlaylistFormNoAuth'
import { CreateCampaignBreadcrumbsNoAuthAds } from '../../Components/CreateCampaignBreadcrumbsNoAuthAds'
import { SearchTrackFormNoAuth } from '../ArtistRegisterPageMetaAds/Components/SearchTrackFormNoAuth/SearchTrackFormNoAuth'

const ContentContainer = styled.div`
  display: flex;
  max-width: 1280px;
  flex-direction: column;
  gap: 80px;
  align-items: center;
`

const TopContentContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 960px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`

export const SearchResourceAdsNoAuth: FC = () => {
  const { strategy } = useParams<{ strategy: AdCampaignStrategyEnum }>()

  return (
    <NoAuthPageLayout>
      <HelmetTitle />
      <ContentContainer>
        <TopContentContainer>
          <CreateCampaignBreadcrumbsNoAuthAds />
          {strategy === AdCampaignStrategyEnum.PLAYLIST && (
            <SearchPlaylistFormNoAuth />
          )}
          {strategy === AdCampaignStrategyEnum.TRACK && (
            <SearchTrackFormNoAuth />
          )}
        </TopContentContainer>
      </ContentContainer>
    </NoAuthPageLayout>
  )
}
